<template>
  <div class="home" :dir="isHebrew ? 'rtl' : 'ltr'">
    <WhatsappChet v-if="!isSubdomain"/>
    <SingleRideHeader  
      :presentedText="t('addActivityToTrip')"
    >
    </SingleRideHeader>
      <div class="trip-card-section after_page_header">
        <div class="container serch_attraction_categories">
          <div class="trip-card-top">
            <div class="search-label">{{ t('searchByLocation') }}</div>
            <div class="search-container">
              <span class="search-icon">🔍</span>
              <GlobalMapSerchAutoComplet
                class="gmap-autocomplete1"
                :placeholder="t('typePlaceName')"
                @handleserchPointChange="handleUpdateserchpoint"
              />
            </div>
            <div class="search-helper-text">{{ t('searchExampleLocations') }}</div>
            <div class="trip-card-top-nav-row">
              <div class="centering">
                <a
                  class="trip-default-btn btn-sky btn-greey trip-card-top-nav-btn"
                  @click="ReturnToSingleRide()"
                >
                  {{ t('backToTrip') }}
                </a>
              </div>
              <div
                v-if="showCreateNewFromSearchNav"
                class="centering"
              >
                <a
                  class="trip-default-btn btn-sky trip-card-top-nav-btn trip-card-top-nav-btn-primary"
                  @click="goToNewAttraction(serchDayIndex)"
                >
                  {{ t('searchAttractionsNoMatchCreateNew') }}
                </a>
              </div>
            </div>
          </div>
          <SerchAttractionCategories
            v-if="(!(isUserManager && compareToUserId(allRide.ride.authorId)) || isSubdomain)"
           />
        </div>
      </div>
      <div class="trip-activity-section">
				<div class="container">
          <div class="row">
            <div class="col-xl-7 col-lg-8">
              <div class="trip-sidebar">
                <SerchAttractions />
              </div>
            </div>
            <div class="col-xl-5 col-lg-4">
              <div class="trip-map-four serch_attraction_map_header">
                <div class="trip-location">
                  <ul>
                    <li>{{ t('activitiesAlreadyInTrip') }}<img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FfullColers%2FpointWithFullColler_07A0C3.png?alt=media&token=c3e342d6-f425-495f-842d-c0e6edd2730e" alt=""></li>
                    <li>{{ t('activitiesMatchSelectedDay') }}<img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fmap_letter%2Fblack_numbers%2Fblack_map_Icon_empty.png?alt=media&token=ae5de8aa-cee4-47a7-966b-e02eb1b93480'" alt=""></li>
                  </ul>
                </div>
                <div >
                  <div >
                    <GlobalMap
                    passed_class="single_ride_map">
                    </GlobalMap>
                  </div>
                  <img src="images/map-two.png" alt="">
                </div>
              </div>
            </div>
          </div>
				</div>
      </div>
    <PageFooter
      v-if="!isSubdomain"
      />
  </div>
</template>

<script>

import PageFooter from '@/components/PageFooter.vue'
import SerchAttractions from '@/components/SerchAttractions';
import GlobalMap from '@/components/GlobalMap';
import SerchAttractionCategories from '@/components/SerchAttractionCategories';
import SingleRideHeader from '@/components/SingleRideHeader';
import GlobalMapSerchAutoComplet from '@/components/GlobalMapSerchAutoComplet';
import WhatsappChet from "@/components/WhatsappChet";
import { mapGetters, mapActions } from 'vuex';
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: 'SerchAtrractionWithMap',
  components: {
    GlobalMapSerchAutoComplet,
    SerchAttractions,
    GlobalMap,
    PageFooter,
    SingleRideHeader,
    SerchAttractionCategories,
    WhatsappChet,
  },
  mixins: [translationMixin],
  computed: { ...mapGetters([  'compareToUserId',
                              'allRide',
                              'isUserManager',
                              'rideIsWhiteLabel',
                              'serchAttractios',
                              'searchAttractionsFilters',
                              'serchDayIndex',
                           ]),
              ...mapGetters("theme",  [ 
                                        "isSubdomain",
                                      ]),
    showCreateNewFromSearchNav() {
      if (!this.allRide || !this.allRide.ride || this.isSubdomain) {
        return false;
      }
      const ride = this.allRide.ride;
      if (ride.ride_manager_id != null) {
        if (this.compareToUserId(ride.ride_manager_id)
        ) {
          return true;
        }
        return false
      }
      if (this.compareToUserId(ride.authorId)) {
        return true;
      }
      return false;
    },
  },

  methods: {
    ...mapActions([ 'updateMarkerByScrollerLocation',
                    'fetchSerchAttractionsByRide',
                    'fetchSerchAttractionsFromRideMangerAcount',
                    'resetSearchAttractionsFilters',
                    'ReturnToSingleRide',
                    'goToNewAttraction' ]),
    handleUpdateserchpoint( place ){
      this.$store.commit('setSerchLat', place.geometry.location.lat());
      this.$store.commit('setSerchLng', place.geometry.location.lng());
      // this one is seting point on the map
      this.$store.commit('setCurrentPlace', place)
      if(this.isUserManager && this.compareToUserId(this.allRide.ride.authorId)){
        this.fetchSerchAttractionsFromRideMangerAcount({ filters: this.searchAttractionsFilters });
      }
      else if(this.rideIsWhiteLabel && this.compareToUserId(this.allRide.ride.authorId)){
        this.fetchSerchAttractionsFromRideMangerAcount();
      }
      else{
        this.fetchSerchAttractionsByRide();
      }
   },
  },
  created(){
    window.addEventListener('scroll', this.updateMarkerByScrollerLocation);
  },
  mounted(){
    this.$store.commit('setPresentedDay', null);
    // this.updateMarkerByScrollerLocation();

      // map stikiness
    const sectionHeroElMap = document.querySelector(".serch_attraction_categories");
    const obsMap = new IntersectionObserver(
      function (entries) {
        const ent = entries[0];
        if ( (ent.isIntersecting === false) && ( ent.boundingClientRect.y < 0) ) {
          document.body.classList.add("serch_attraction_map_sticky");
        }
        if (ent.isIntersecting === true) {
          document.body.classList.remove("serch_attraction_map_sticky");
        }
      },
      {
        // In the viewport
        root: null,
        threshold: 0,
        rootMargin: "-40px",
      }
    );
    obsMap.observe(sectionHeroElMap);
  },
  watch: {
    serchAttractios() {
      this.updateMarkerByScrollerLocation();
      // in order to update the icons on the sertch map
    },
  },
  destroyed(){
    this.resetSearchAttractionsFilters();
    window.removeEventListener('scroll', this.updateMarkerByScrollerLocation);
  },
  
};


</script>

<style scoped>

.trip-card-top {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 16px; /* add horizontal padding for small screens */
}

.search-label {
  font-weight: bold;
  font-size: 16px;
  color: #333;
  width: 100%;
}

.home[dir="rtl"] .trip-card-top,
.home[dir="ltr"] .trip-card-top {
  text-align: center !important;
}

.home[dir="rtl"] .trip-card-top .search-label,
.home[dir="ltr"] .trip-card-top .search-label {
  text-align: center !important;
}

.search-container {
  position: relative;
  display: flex; /* was 'block' — now flex for better layout */
  align-items: center;
  justify-content: center; /* center the input and icon */
  background: #f0f0f0;
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto; /* center horizontally */
  box-sizing: border-box;
}

[dir="rtl"] .search-container {
  flex-direction: row-reverse;
}

[dir="ltr"] .search-container {
  flex-direction: row;
}

.search-icon {
  margin-inline-end: 8px;
  font-size: 18px;
  color: #555;
}

.search-helper-text {
  font-size: 12px;
  color: #666;
  width: 100%;
}

.home[dir="rtl"] .trip-card-top .search-helper-text,
.home[dir="ltr"] .trip-card-top .search-helper-text {
  text-align: center !important;
}

.trip-card-top-nav-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}

[dir="rtl"] .trip-card-top-nav-row {
  flex-direction: row-reverse;
}

.trip-card-top-nav-row .centering {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Same button family as elsewhere; row-friendly sizing (override global trip-default-btn flex) */
.trip-card-top-nav-row a.trip-card-top-nav-btn {
  flex: 0 1 auto !important;
  width: auto;
  max-width: 100%;
  min-width: 0;
  margin-bottom: 0 !important;
  font-size: 14px;
  line-height: 1.35;
  padding: 10px 18px;
  text-decoration: none;
}

.trip-card-top-nav-row a.trip-default-btn.btn-greey {
  background: #6c757d !important;
  border: 1px solid #6c757d !important;
  color: #fff !important;
}

.trip-card-top-nav-row a.trip-default-btn.btn-greey:hover {
  background: #5a6268 !important;
  border-color: #5a6268 !important;
  color: #fff !important;
}

.trip-card-top-nav-row a.trip-card-top-nav-btn-primary {
  background: var(--primary-background, #07a0c3) !important;
  color: var(--primary-text-color, #fff) !important;
  border: 1px solid transparent;
}

.trip-card-top-nav-row a.trip-card-top-nav-btn-primary:hover {
  filter: brightness(0.95);
}

/* ✅ Responsive adjustments for mobile screens */
@media (max-width: 600px) {
  .gmap-autocomplete1 {
    width: 100% !important;
    max-width: 100%;
  }

  .search-container {
    padding: 8px;
  }

  .search-icon {
    font-size: 16px;
    margin-inline-end: 4px;
  }

  .search-label,
  .search-helper-text {
    font-size: 14px;
  }

  .trip-card-top-nav-row {
    flex-direction: column;
  }

  [dir="rtl"] .trip-card-top-nav-row {
    flex-direction: column;
  }

  .trip-card-top-nav-row .centering {
    width: 100%;
  }

  .trip-card-top-nav-row a.trip-card-top-nav-btn {
    width: 100%;
    justify-content: center;
  }
}

.gmap-autocomplete1 {
  width: 100% !important;
  max-width: 500px;
  box-sizing: border-box; /* ensures padding doesn't overflow */
}

::v-deep .gmap-autocomplete1 {
  font-size: 16px !important;
  line-height: 22px;
}
.abit_right{
  padding-right: 70%;
}
.sidebar{
  position: fixed;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

[dir="ltr"] .trip-location ul li {
  padding-left: 35px !important;
  padding-right: 0 !important;
}

[dir="ltr"] .trip-location ul li img {
  left: 0 !important;
  right: auto !important;
}

[dir="rtl"] .trip-location ul li {
  padding-right: 35px !important;
  padding-left: 0 !important;
}

[dir="rtl"] .trip-location ul li img {
  right: 0 !important;
  left: auto !important;
}

</style>
